export default __webpack_public_path__ + "static/media/element_spec_28.42666e47.webp";